import type { Action } from 'redux';

export interface KeyedAction extends Action<string> {
  dataKey?: string;
  params?: { storage_key?: string };
}

export const resolveStorageKey = (action: KeyedAction): string | undefined => {
  if (
    Object.prototype.hasOwnProperty.call(action, 'params') &&
    action.params &&
    Object.prototype.hasOwnProperty.call(action.params, 'storage_key')
  ) {
    return action.params.storage_key;
  }
  return action.dataKey;
};
